import { useEffect, useRef } from 'react';

export const usePollingControl = (isPollingEnabled: boolean, stopPolling: () => void) => {
  const wasPollingEnabledRef = useRef(false);

  useEffect(() => {
    if (isPollingEnabled) {
      wasPollingEnabledRef.current = true;
    } else if (wasPollingEnabledRef.current) {
      stopPolling();
      wasPollingEnabledRef.current = false;
    }
  }, [isPollingEnabled, stopPolling]);
};
